const checklistConstants = {
	feature: "@checklist",
	forms: {
		FILTER: "FILTER",
	},
};

export const CHECKLIST_PER_PAGE = 10;
export default checklistConstants;